module.exports = __webpack_public_path__ + "static/mr-press-21-326667b76e6b423fbe8281f23f9638aa.jpg";